import Paginator from '@creditflowresearch/uilib/Paginator';
import DataTable, { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import { Tile } from '@creditflowresearch/uilib/Tile';

import ArticlesTileContextProvider, {
  useArticlesTileContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/ArticlesTileContext';
import { useGetLinkToAllArticles } from '@/creditflowresearch/ui/components/creditFlow/articles/common/useGetLinkToAllArticles';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import ArticlesTileHeader from './TileHeader';
import getColumns from './columns';

import styles from './articlesTile.module.scss';

const EmptyMessage = ({ type }) => {
  const { link } = useGetLinkToAllArticles(type);

  return (
    <div className={ styles.emptyMessage }>
      Explore all other&nbsp;
      <a href={ link }>Commentary & Deal Flow</a>
    </div>
  );
};

const ArticlesTile = ({ themeType }) => {
  const {
    articlesData: {
      collection,
      totalCount,
      perPage,
      page,
      isFetching,
      paginate,
    },
  } = useArticlesTileContext();
  const { timeZone } = useUserTimeZoneContext();

  return (
    <Tile dataTest={ `articlesTile-${ themeType }` } className={ styles.container }>
      <ArticlesTileHeader />
      { collection.length === 0 ? (
        <EmptyMessage type={ themeType } />
      ) : (
        <div className={ styles.tableWrapper }>
          <DataTable
            dataTest="bwicSummaryDataTable"
            columns={ getColumns(themeType, timeZone) }
            data={ collection }
            loadingComponent={ Spinner }
            isFetching={ isFetching }
            isHeaderVisible={ false }
            className={ dataTableStyles.isHoverable }
          />
          <Paginator
            dataTest="bwicSummaryTable"
            page={ page }
            perPage={ perPage }
            totalCount={ totalCount }
            onPageChange={ ({ selected }) => paginate(selected) }
            isItemsPerPageVisible={ false }
          />
        </div>
      ) }
    </Tile>
  );
};

export default ({
  initialData,
  themeType,
  isSubscribeButtonVisible,
}) => (
  <ArticlesTileContextProvider
    initialData={ initialData }
    themeType={ themeType }
    isSubscribeButtonVisible={ isSubscribeButtonVisible }
  >
    <ArticlesTile themeType={ themeType } />
  </ArticlesTileContextProvider>
);
